import axios from 'axios';

export const getEpiPage = async (apiUrl: string, route: string) => {
	const appendUrl = '.json';

	// Extract the hash fragment (#anchor) first, so it doesn't end up in the
	// middle of the URL once '.json' is appended below. It's added back at
	// the very end, after the '.json' suffix and query string.
	let hash = '';
	const hashIndex = route.indexOf('#');
	if (hashIndex > -1) {
		hash = route.substring(hashIndex);
		route = route.substring(0, hashIndex);
	}

	if (route === '') {
		route = `index${appendUrl}`;
	} else if (route.indexOf('?') > -1) {
		let index = route.indexOf('?');
		let query = route.substring(index);
		route = route.substring(0, index);

		if (route.endsWith('/')) {
			route += `index${appendUrl}`;
		} else {
			route += appendUrl;
		}

		route += query;
	} else {
		route += appendUrl;
	}

	const url = `${apiUrl}${route}${hash}`;
	const { data } = await axios({
		url,
		method: 'GET',
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
			'content-type': 'application/json; charset=utf-8',
		},
	});
	return data;
};